// extracted by mini-css-extract-plugin
export default {"getOrderSkelletons":"GetOrdersSkelleton_getOrderSkelletons__Cp5CB","getOrderSkelleton":"GetOrdersSkelleton_getOrderSkelleton__MRHV7"};